import React, { useState, useEffect } from "react";
import { Button, Modal, Radio } from "antd";
import CoinImage from "../../assets/images/coin_big_icons.svg";
import CheckImage from "../../assets/images/check-orange-image.svg";
import PlusImage from "../../assets/images/plus-image.svg";
import KNETIcon from "../../assets/images/Knet-iconnn.svg";
import APPLEIcon from "../../assets/images/Apple-iconnn.svg";
import GOOGLEIcon from "../../assets/images/Google-iconnn.svg";
import CREDITCARDIcon from "../../assets/images/CreditCardiconnn.svg";
import IICONimage from "../../assets/images/i-icon-mainhj.svg";
import Main from "../../components/layout/Main";
import { useWallet } from "../../context/WalletContext";
import { chargePayment } from "../../helper/functions";
import { ShowToast, Severty } from "../../helper/toast";
import { useNavigate, useLocation } from "react-router-dom";
const BuyTokenIndex = () => {
  // ---------- constants -------------
  const [selectedPackage, setSelectedPackage] = useState();
  const [packageData, setPackageData] = useState();
  const [tokens, setTokens] = useState();
  const [selectedPayment, setSelectedPayment] = useState("KNET");
  const { loadTokenBundles, addPayIn } = useWallet();
  const userProfileData = JSON.parse(localStorage.getItem("userProfile"));
  const navigate = useNavigate();
  const location = useLocation();
  const [isConfirmPaymentModalOpen, setIsConfirmPaymentModalOpen] =
    useState(false);

  const showModal = () => {
    setIsConfirmPaymentModalOpen(true);
  };

  // -------------- handlers -------------
  const handleCancel = () => {
    setIsConfirmPaymentModalOpen(false);
  };

  const fetchTokenBundles = async () => {
    const response = await loadTokenBundles();
    setTokens(response?.data?.tokenBundles);
  };

  const handlePurchaseToken = async (packageData) => {
    try {
      const baseUrl = window.location.origin;
      // save bundle  data in localstorage
      localStorage.setItem(
        "tokenBundleData",
        JSON.stringify({
          amount: packageData?.bundlePrice,
          notes: `Top-up via ${selectedPayment}`,
        })
      );
      // ----------- Here called api to U Payments -----------
      const data = {
        order: {
          id: packageData?._id,
          description: `Payment for Order ${"ORD" + packageData?._id}`,
          currency: "KWD",
          amount: packageData?.bundlePrice,
        },
        paymentGateway: {
          src: selectedPayment,
        },
        language: "en",
        tokens: {
          customerUniqueToken: Number(userProfileData?.customerUniqueToken),
        },
        reference: {
          id: Date.now().toString(),
        },
        customer: {
          uniqueId: userProfileData?._id,
          name: userProfileData?.name,
          email: userProfileData?.email,
          mobile: userProfileData?.phone,
        },
        returnUrl: `${baseUrl}/wallet/buy-token`,
        cancelUrl: `${baseUrl}/wallet/buy-token`,
        notificationUrl: `${baseUrl}/wallet/buy-token`,
      };
      const response = await chargePayment(data);
      const link = response.data.link;
      window.location.href = link;
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  // --------- call the post api if payment is successfull -------------
  const handlePayIn = async (paymentResult) => {
    const storedData = JSON.parse(localStorage.getItem("tokenBundleData"));
    const data = {
      amount: storedData.amount,
      notes: storedData.notes,
      status: "Completed",
      gatewayResponse: paymentResult,
    };
    const response = await addPayIn(data);
    if (response.success) {
      navigate("/wallet");
    }
  };

  // -------------- variables -------------
  const paymentOptions = [
    { label: "KNET", value: "knet", icon: KNETIcon },
    { label: "Apple Pay", value: "apple-pay", icon: APPLEIcon },
    { label: "Google Pay", value: "google-pay", icon: GOOGLEIcon },
    { label: "Credit Card", value: "cc", icon: CREDITCARDIcon },
  ];
  // ---------- use effect -----------
  useEffect(() => {
    fetchTokenBundles();
  }, []);

  // when payment is confirmed
  useEffect(() => {
    console.log("location search --->", location.search);
    if (!location.search) return;
    const paymentResult = Object.fromEntries(
      new URLSearchParams(location.search)
    );
    if (
      paymentResult.result === "CAPTURED" ||
      paymentResult.result === "NOT CAPTURED"
    ) {
      ShowToast("Payment Successful", Severty.SUCCESS);
      handlePayIn(paymentResult);
    } else {
      ShowToast("Payment Failed", Severty.ERROR);
    }
    // 🔥 clear query params
    navigate("/wallet/buy-token", { replace: true });
  }, [location.search]);

  return (
    <Main>
      <div className="wallet-page">
        <div className="orange-header">Select Package</div>

        <div className="buy-token-main">
          {tokens?.map((pkg, index) => {
            const isSelected = selectedPackage === index;

            return (
              <div
                key={index}
                className={`buy-token-inner ${
                  isSelected ? "active-package" : ""
                }`}
                onClick={() => {
                  setSelectedPackage(index);
                  setPackageData(pkg);
                }}
              >
                <div className="buy-token-inner-img">
                  <img src={CoinImage} alt="coin" />
                </div>
                <div className="buy-token-inner-text">
                  <span>
                    <h5>{pkg.tokensQty} TKN</h5>
                    <h6>KWD {pkg.bundlePrice}</h6>
                  </span>
                  <span>
                    {isSelected ? (
                      <span>
                        <img src={CheckImage} />
                      </span>
                    ) : (
                      <span>
                        <img src={PlusImage} />
                      </span>
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {selectedPackage !== null && selectedPackage !== undefined && (
          <>
            <div className="orange-header">Choose Payment Method</div>

            <div className="payment-method-section">
              {paymentOptions.map((method, index) => (
                <div
                  key={method.label}
                  className={`payment-card ${
                    selectedPayment === method.value ? "selected" : ""
                  }`}
                  onClick={() => setSelectedPayment(method.value)}
                >
                  <div className="payment-left">
                    <img
                      src={method.icon}
                      alt={method.label}
                      className="payment-icon"
                    />
                    <span>{method.label}</span>
                  </div>

                  <div className="payment-right">
                    <Radio
                      checked={selectedPayment === method.value}
                      onChange={() => setSelectedPayment(method.value)}
                    />
                  </div>
                </div>
              ))}

              <div className="daily-trabsfer-limiit daily-trabsfer-limiit-margin">
                <img src={IICONimage} />
                <div className="daily-trabsfer-limiit-text">
                  <p>
                    Your payment will be processed securely through our payment
                    gateway.
                  </p>
                </div>
              </div>

              <Button
                className="Fill-button"
                onClick={() => handlePurchaseToken(packageData)}
              >
                Confirm Payment
              </Button>

              <Modal
                open={isConfirmPaymentModalOpen}
                onOk={() => setIsConfirmPaymentModalOpen(false)}
                onCancel={handleCancel}
                footer={null}
                width={452}
                centered
                className="ConfirmPaymentColor"
              >
                <div className="confirm-payement-modaal">
                  <img src={CheckImage} />
                  <h2>Purchased Successful</h2>
                  <p>You’ve successfully purchased 500 Tokens.</p>
                  <div className="secess-modal-footer">
                    <Button
                      className="Fill-button-small"
                      onClick={() => {
                        setIsConfirmPaymentModalOpen(false);
                        navigate("/wallet");
                      }}
                    >
                      Return to Wallet
                    </Button>
                    <Button
                      className="light-button"
                      onClick={() => {
                        setIsConfirmPaymentModalOpen(false);
                        navigate("/stores");
                      }}
                    >
                      Explore Store
                    </Button>
                  </div>
                </div>
              </Modal>
            </div>
          </>
        )}
      </div>
    </Main>
  );
};

export default BuyTokenIndex;
